export const notStarted = "notStarted";
export const started = "Started";
export const submitted = "Submitted";
export const rejected = "Rejected";
export const resubmitted = "Resubmitted";
export const scored = "Scored";
export const completed = "Completed"